import { render, staticRenderFns } from "./edit-GST.vue?vue&type=template&id=d72eda9a&"
import script from "./edit-GST.vue?vue&type=script&lang=js&"
export * from "./edit-GST.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports